import { render } from "./HotelReservationComponent.vue?vue&type=template&id=6c2cebf6"
import script from "./HotelReservationComponent.vue?vue&type=script&lang=js"
export * from "./HotelReservationComponent.vue?vue&type=script&lang=js"

import "./HotelReservationComponent.vue?vue&type=style&index=0&id=6c2cebf6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__